<template>
  <ul class="m-menu__nav  m-menu__nav--submenu-arrow flex ml-auto">
    <router-link v-if="authCheck" :to="{ name: 'agenda.index' }" tag="li" activeClass="m-menu__item--active" class="m-menu__item" m-menu-submenu-toggle="hover">
      <a class="m-menu__link">
        <i class="m-menu__link-icon fa fa-calendar"></i>
        <span class="m-menu__link-title">
            <span class="m-menu__link-wrap">
              <span class="m-menu__link-text">
                Agenda
              </span>
            </span></span>
      </a>
    </router-link>

    <router-link v-if="authCheck && isAdmin" :to="{ name: 'users.index' }" tag="li" activeClass="m-menu__item--active" class="m-menu__item" m-menu-submenu-toggle="hover">
      <a class="m-menu__link">
        <i class="m-menu__link-icon fa fa-users"></i>
        <span class="m-menu__link-title">
            <span class="m-menu__link-wrap">
              <span class="m-menu__link-text">
                Resources
              </span>
            </span>
          </span>
      </a>
    </router-link>

    <router-link v-if="authCheck && !isSimple" :to="{ name: 'clients.index' }" tag="li" activeClass="m-menu__item--active" class="m-menu__item" m-menu-submenu-toggle="hover">
      <a class="m-menu__link">
        <i class="m-menu__link-icon fa fa-child"></i>
        <span class="m-menu__link-title">
            <span class="m-menu__link-wrap">
              <span class="m-menu__link-text">
                Clients
              </span>
            </span>
          </span>
      </a>
    </router-link>

    <router-link v-if="authCheck" :to="{ name: 'account.index' }" tag="li" activeClass="m-menu__item--active" class="m-menu__item  m-menu__item--submenu" m-menu-submenu-toggle="hover">
      <a class="m-menu__link">
        <i class="m-menu__link-icon fa fa-user"></i>
        <span class="m-menu__link-text">
            Account
          </span>
      </a>
    </router-link>

    <router-link v-if="authCheck && isAdmin" :to="{ name: 'reports.index' }" tag="li" activeClass="m-menu__item--active" class="m-menu__item  m-menu__item--submenu" m-menu-submenu-toggle="hover">
      <a class="m-menu__link">
        <i class="m-menu__link-icon fas fa-chart-area"></i>
        <span class="m-menu__link-text">
            Reports
          </span>
      </a>
    </router-link>

    <router-link v-if="authCheck && isAdmin" :to="{ name: 'financialReports.index' }" tag="li" activeClass="m-menu__item--active" class="m-menu__item  m-menu__item--submenu" m-menu-submenu-toggle="hover">
      <a class="m-menu__link">
        <i class="m-menu__link-icon fas fa-dollar"></i>
        <span class="m-menu__link-text">
            Financial Reports
          </span>
      </a>
    </router-link>

    <!--<router-link v-if="authCheck && isAdmin" :to="{ name: 'invoices.index' }" tag="li" activeClass="m-menu__item&#45;&#45;active" class="m-menu__item  m-menu__item&#45;&#45;submenu" m-menu-submenu-toggle="hover">-->
      <!--<a class="m-menu__link">-->
        <!--<i class="m-menu__link-icon fas fa-file"></i>-->
        <!--<span class="m-menu__link-text">-->
            <!--Invoices-->
          <!--</span>-->
      <!--</a>-->
    <!--</router-link>-->

    <router-link v-if="authCheck && isAdmin" :to="{ name: 'invoices2.index' }" tag="li" activeClass="m-menu__item--active" class="m-menu__item  m-menu__item--submenu" m-menu-submenu-toggle="hover">
      <a class="m-menu__link">
        <i class="m-menu__link-icon fas fa-file"></i>
        <span class="m-menu__link-text">
            Invoices
          </span>
      </a>
    </router-link>

    <router-link v-if="authCheck && isAdmin" :to="{ name: 'mails.index' }" tag="li" activeClass="m-menu__item--active" class="m-menu__item  m-menu__item--submenu" m-menu-submenu-toggle="hover">
      <a class="m-menu__link">
        <i class="m-menu__link-icon fas fa-envelope"></i>
        <span class="m-menu__link-text">
            Mail
          </span>
      </a>
    </router-link>

    <li v-if="authCheck" class="m-menu__item" m-menu-submenu-toggle="hover" @click="logout">
      <a class="m-menu__link ">
        <i class="m-menu__link-icon fa fa-sign-out"></i>
        <span class="m-menu__link-title">
            <span class="m-menu__link-wrap">
              <span class="m-menu__link-text">
                Logout
              </span>
            </span>
          </span>
      </a>
    </li>
  </ul>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex'

  export default {
    methods: {
      ...mapActions('auth', ['logout'])
    },
    computed: {
      ...mapGetters('auth', ['authCheck', 'isAdmin', 'isSimple'])
    },
    mounted() {
      // hide sidebar when clicked on menu item @small screens
      document.querySelectorAll('.m-menu__link').forEach(el => {
        el.addEventListener('click', e => {
          const el = document.querySelector('.m-aside-left-overlay')
          if (el) {
            el.click()
          }
        })
      })
    }
  }
</script>

<style type="scss">
  .m-brand {
    width: 150px;
  }

  .m-aside-left {
    width: 150px;
  }

  .m-menu__item {
    width: 150px;
  }

  .m-menu__link {
    padding: 0 0 0 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue